import {WalletConnectOptions} from '@web3-react/walletconnect-v2';
import {CoinbaseWalletSDKOptions} from '@coinbase/wallet-sdk/dist/CoinbaseWalletSDK';
export {
  Web3Provider,
  JsonRpcSigner as Web3JsonRpcSigner,
} from '@ethersproject/providers';

export enum Web3ConnectionType {
  WALLET_CONNECT = 'WALLET_CONNECT',
  URL = 'URL',
  NETWORK = 'NETWORK',
  METAMASK = 'METAMASK',
  GNOSIS_SAFE = 'GNOSIS_SAFE',
  EMPTY = 'EMPTY',
  EIP1193 = 'EIP1193',
  COINBASE = 'COINBASE',
}

export interface Web3ConnectOptions {
  defaultChainId: number;
  defaultConnectionType?: Web3ConnectionType;
  walletConnect: WalletConnectOptions;
  coinbase: Omit<CoinbaseWalletSDKOptions, 'url'>;
  urls: Record<number, string[]>;
}
